// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const slakoth: PokeData = {
  "id": 287,
  "name": "slakoth",
  "height": 8,
  "weight": 240,
  "base_experience": 56,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "headbutt",
    "counter",
    "amnesia",
    "rest",
    "flail",
    "feint-attack",
    "encore",
    "yawn",
    "slack-off",
    "covet",
    "chip-away",
    "play-rough",
    "throat-chop"
  ],
  "moves": [
    "scratch",
    "headbutt",
    "play-rough",
    "body-slam",
    "tri-attack",
    "scary-face",
    "tackle",
    "purification",
    "leer",
    "splash",
    "quick-attack",
    "refresh",
    "protect"
  ],
  "evolution_chain": {
    "id": 143,
    "item": null,
    "species": [
      {
        "name": "slakoth",
        "order": 313,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "vigoroth",
        "order": 314,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 287,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "slaking",
        "order": 315,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 288,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 53.75,
    "speed": 30,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
